import { render, staticRenderFns } from "./Casesse.vue?vue&type=template&id=2784ddb6&scoped=true&"
import script from "./Casesse.vue?vue&type=script&lang=js&"
export * from "./Casesse.vue?vue&type=script&lang=js&"
import style0 from "./Casesse.vue?vue&type=style&index=0&id=2784ddb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2784ddb6",
  null
  
)

export default component.exports